import IllumioDomUtils from "../common/dom_utils.js";
import { IllumioEventEmitter } from "../common/event_emitter.js";
import IllumioSupportUtils from "../common/support_utils.js";

export class EndpointOsSupportModel extends IllumioEventEmitter {
    constructor() {
        super();

        // this.dataLoadEvent = new Event(this);
        let url = '/api/v1/pce_software/os_support/endpoint.json'
        if (IllumioSupportUtils.isPublicResource()) {
            url = '/api/v1/shared/pce_software/os_support/endpoint.json'
        }
        $.ajax({
            dataType: 'json',
            method: 'get',
            contentType: 'application/json; charset=utf-8',
            url: url,
            error: this.ajaxErrorHandler.bind(this),
            success: this.ajaxSuccessHandler.bind(this),
        });
    }

    ajaxSuccessHandler(response, textStatus, jqXHR) {
        console.debug('ajaxSuccessHandler() invoked.');
        if (response && response.data) {
            this.success = true;
            this.data = response.data;
            // this.dataLoadEvent.notify();
            this.emit('dataLoad', {});
        } else {
            this.success = false;
            this.error = response.error;
        }
    }

    ajaxErrorHandler() {
        console.warn('ajaxErrorHandler() invoked.');
        const result = new EndpointOsSupportResult();
        result.renderError(null);
    };

        /**
         * Public method
         */
        getRecordByVersion(endpointVersion) {
            if (this.data['os_content']) {
                for (let id in this.data['os_content']) {
                    if (this.data['os_content'][id].software_version===endpointVersion) {
                        return this.data['os_content'][id];
                    }
                }
            }

            return null;
        }
}

export class EndpointOsSupportView extends IllumioEventEmitter {
    constructor(model) {
        super();

        this.model = model;
        this.formDiv = document.getElementById('formDiv');
        this.endpointVersionSelect = document.getElementById('endpointVersionSelect');

        this.endpointVersionSelect.onchange = this.endpointVersionSelectOnChangeHandler.bind(this);

        // this.model.dataLoadEvent.attach(dataLoadEventHandler.bind(this));
        this.model.on('dataLoad', this.dataLoadEventHandler.bind(this));

        this.result = new EndpointOsSupportResult();
    }

        /**
         * Public method
         */
        showResult(id) {
            if (!id && this.endpointVersionSelect && this.endpointVersionSelect.options.selectedIndex>=0) {
                id = this.endpointVersionSelect.options[this.endpointVersionSelect.options.selectedIndex].value
            }

            console.debug(`selected id: ${id}`);
            this.result.render(this.model.data['os_content'][id], this.model.data['compatibility'][this.model.data['os_content'][id]['software_version']]);

            location.hash = this.model.data['os_content'][id].software_version;

            this.trackAnalytic();
        }

    endpointVersionSelectOnChangeHandler(event) {
        console.debug('endpointVersionSelsectOnChangeHandler() invoked');
        this.showResult(event.target.value);
    }

    dataLoadEventHandler(event) {
        console.debug('dataLoadEventHandler() invoked!');
        if (this.model.success && this.model.data['os_content']) {
            let itemCounter = 0;
            const optionsArray = new Array();
            for (let id in this.model.data['os_content']) {
                const item = this.model.data['os_content'][id];

                let text = item.software_version;
                if (item.lts) {
                    text += ' (LTS)';
                }

                optionsArray.push(new Option(text, item.id));
            }
            if (optionsArray.length>0) {
                const optionsArraySortHandler = function(a, b) {
                    if (a.text>b.text) {
                        return -1;
                    } else if (a.text<b.text) {
                        return 1;
                    }
                    return 0;
                }
                optionsArray.sort(optionsArraySortHandler);

                const optionsArrayForEachHandler = function(optionItem) {
                    console.debug(optionItem);
                    console.debug(this);
                    this.endpointVersionSelect.options.add(optionItem);
                }
                optionsArray.forEach(optionsArrayForEachHandler.bind(this), this);
            }
            if (this.endpointVersionSelect.options.length>0) {
                this.defaultEndpointVersionSelect();
                this.formDiv.classList.remove('hidden');
                $(this.endpointVersionSelect).change();
            } else {
                this.result.renderError(null);
            }
        }
    }

    defaultEndpointVersionSelect() {
        let found = false;
        if (location.hash && location.hash.length>1) {
            const record = this.model.getRecordByVersion(location.hash.substr(1));
            if (record) {
                for (let i=0;i<this.endpointVersionSelect.options.length;i++) {
                    if (this.endpointVersionSelect.options[i].text===record.software_version) {
                        found = true;
                        this.endpointVersionSelect.options[i].selected = true;
                        break;
                    }
                }
            }
        }

        if (!found) {
            this.endpointVersionSelect.options.selectedIndex = 0;
        }
    }

    trackAnalytic() {
        if (IllumioSupportUtils && this.endpointVersionSelect.selectedIndex>=0) {
            const eventLabel = this.endpointVersionSelect.options[this.endpointVersionSelect.selectedIndex].text;
            console.debug(`eventLabel: ${eventLabel}`);
            IllumioSupportUtils.trackGaEvent('OS Support', 'ENDPOINT', eventLabel);
        }

        const qs = IllumioSupportUtils.getJsonFromUrl(location.href);
        if (qs && qs['source']) {
            IllumioSupportUtils.trackGaEvent('OS Support', 'ENDPOINT Redirect', qs['source'])
            console.debug('Tracked ENDPOINT redirect');
        }

    }
}

export class EndpointOsSupportController {
    constructor(model, view) {
        this.model = model;
        this.view = view;
    }
}

export class EndpointOsSupportResult {
    constructor() {
        this.endpointContent = document.getElementById('endpointContent');
    };

        /**
         * Public method
         */
        render(record, compatibility) {
            this.endpointContent.innerHTML = this.createCompatibilityTable(record, compatibility);
            this.endpointContent.innerHTML += record.view;
            this.updateHeading(record);
        }

        /**
         * Public method
         */
        renderError(message) {
            if (!message) {
                message = `We're sorry that we have experienced technical difficulties in retrieving the content. Please try again later.`;
            }
            this.endpointContent.innerHTML = message;
        }

    createCompatibilityTable(record, compatibility) {
        let compatability_html = "<h2>COMPATIBILITY</h2>";
        compatability_html += "<table class='ilo-tabular'><tbody><tr><th>Software type</th><th>Version</th></tr><tr><td>PCE</td><td><ul>";
        for (let i in compatibility) {
            compatability_html += `<li>${compatibility[i]}</li>`;
        }
        compatability_html += "</ul></tr></tbody></table>";
        return compatability_html;
    }

    // This code assumes that the last item in the table is the qualified header, and will add the qualified class to the 2nd last column
    updateTables() {
        const tables = $("table");
        console.log('update tables tables :',tables);
        tables.addClass('ilo-tabular');

        const table = tables[1];
        console.log('update tables table :',table);
        const tbody = table.children[1];
        const header = tbody.children[0];
        // Check if the header has 3 items for backwards compatability
        if (!header.children[2]) {
            return;
        }
        table.style.width = "";

        // There is an unneccasary colgroup in the HTML here
        table.removeChild(table.children[0]);


        // Delete the "qualified" header then grab the rest of it
        header.removeChild(header.children[2]);



        let index = 1;
        const versions = [];
        let version_to_replace = null;
        while (tbody.children[index]) {
            if (tbody.children[index].children.length == 5) {
                let qualified_index = 2;
                tbody.children[index].removeChild(tbody.children[index].children[qualified_index]);
                versions.push(tbody.children[index].children[qualified_index-1].innerText);
                version_to_replace = tbody.children[index].children[qualified_index-1];
                index += 1
            } else {
                let qualified_index = 1;
                versions.push(tbody.children[index].children[qualified_index-1].innerText);
                tbody.removeChild(tbody.children[index]);
            }
        }

        let new_versions_to_replace_html = '<ul>';
        for (let i = 0; i < versions.length; i++) {
            new_versions_to_replace_html += `<li>${versions[i]}</li>`;
        }
        new_versions_to_replace_html += '</ul>';
        version_to_replace.innerHTML = new_versions_to_replace_html;
    }

    updateHeading(record) {
        const sections = $('.sectionMacroRow');
        for (let i=1;i<sections.length;i++) {
            sections[i].outerHTML += "<br>";
        }

        const headings = document.getElementsByTagName('h2');
        for (let i=0;i<headings.length;i++) {
            headings[i].textContent += ` for Illumio ENDPOINT VEN ${record.software_version}`;
            console.debug(headings[i].textContent);
        }
    }
}
